var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgApplePayDark(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.79 13.352c-.18.419-.392.805-.638 1.16-.335.483-.61.818-.822 1.004-.328.305-.68.461-1.057.47-.27 0-.596-.077-.976-.235-.38-.157-.73-.235-1.05-.235a2.87 2.87 0 00-1.081.235c-.386.158-.697.24-.934.248-.361.016-.721-.145-1.08-.483-.23-.202-.517-.549-.86-1.04a7.224 7.224 0 01-.91-1.826A6.75 6.75 0 015 10.474c0-.804.172-1.498.516-2.079.27-.467.63-.835 1.082-1.105.45-.27.937-.409 1.461-.417.287 0 .663.09 1.131.266.466.176.766.266.897.266.098 0 .43-.105.994-.314.533-.194.983-.274 1.352-.242.999.081 1.75.479 2.248 1.196-.893.547-1.335 1.313-1.326 2.296.008.766.283 1.403.823 1.91.244.234.518.415.822.544a9.068 9.068 0 01-.21.557zM12.5 4.24c0 .6-.217 1.16-.65 1.68-.521.616-1.152.972-1.837.916A1.892 1.892 0 0110 6.608c0-.576.248-1.192.69-1.696.22-.256.499-.468.838-.637.339-.167.659-.26.96-.275.009.08.013.16.013.24z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}
export default SvgApplePayDark;